/**
 * Provides service functions for retrieving and updating widget
 * configuration settings, including loading configuration changes
 * used to control dashboard widget behavior and presentation.
 */
import { api } from "@/api";

export async function getWidgetConfigurations(): Promise<any> {
  const res = await api.widgetConfigurations();
  return res;
}

export async function updateWidgetConfigurations(
  payload: any,
): Promise<any> {
  const res = await api.widgetConfigurationsUpdate(payload);
  return res;
}

export async function getwidgetConfigChanges(): Promise<any> {
  const res = await api.widgetConfigChanges();
  return res;
}

